import { Route, mapToCanActivate } from '@angular/router';
import { AuthNGuard } from '@daas-consulting/security/authentication/frontend/utils';

export const SecuritySigninRoute: Route = {
  path: 'login',
  pathMatch: 'full',
  loadComponent() {
    return import(
      '@daas-consulting/security/authentication/frontend/pages'
    ).then((c) => c.AuthenticationSigninFormPageComponent);
  },
};

export const SecurityAuthenticationAuthenticationCallbackRoute: Route = {
  path: 'security/authentication/callback',
  loadComponent() {
    return import(
      '@daas-consulting/security/authentication/frontend/pages'
    ).then((c) => c.AuthenticationCallbackPageComponent);
  },
};

export const SecurityAuthenticationLogoutRoute: Route = {
  path: 'logout',
  loadComponent() {
    return import(
      '@daas-consulting/security/authentication/frontend/pages'
    ).then((c) => c.AuthenticationLogoutPageComponent);
  },
};

export const SecurityAuthenticationGenerateQrCodeRoute: Route = {
  path: 'security/2fa/generate',
  pathMatch: 'full',
  loadComponent() {
    return import(
      '@daas-consulting/security/authentication/frontend/pages'
    ).then((c) => c.AuthenticationGenerateQrCodePageComponent);
  },
  canActivate: [...mapToCanActivate([AuthNGuard])],
};

export const SecurityAuthenticationTurnOnRoute: Route = {
  path: 'security/2fa/turn-on',
  pathMatch: 'full',
  loadComponent() {
    return import(
      '@daas-consulting/security/authentication/frontend/pages'
    ).then((c) => c.AuthenticationTurnOnPageComponent);
  },
  canActivate: [...mapToCanActivate([AuthNGuard])],
};

export const SecurityAuthenticationValidateRoute: Route = {
  path: 'security/2fa/validate',
  pathMatch: 'full',
  loadComponent() {
    return import(
      '@daas-consulting/security/authentication/frontend/pages'
    ).then((c) => c.AuthenticationValidatePageComponent);
  },
  canActivate: [...mapToCanActivate([AuthNGuard])],
};

export const SecurityAuthenticationUnauthorizedRoute: Route = {
  path: 'unauthorized',
  pathMatch: 'full',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  children: [
    {
      path: '',
      loadComponent() {
        return import(
          '@daas-consulting/security/authentication/frontend/pages'
        ).then((c) => c.UnauthorizedPageComponent);
      },
    },
  ],
};
